import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {Stocktaking} from "../../../model/stocktaking";
import {ApolloQueryObservable} from "apollo-angular";
import {FetchStocktakingsQuery} from "../../../../shared/graphql/graphql.types";
import {StocktakingService} from "../../../services/stocktaking/stocktaking.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FileService} from "../../../../core/visbos-core/http/file.service";

@Component({
  selector: 'vb-stocktakings-list-view',
  templateUrl: './stocktakings-list-view.component.html',
  styleUrls: ['./stocktakings-list-view.component.css']
})
export class StocktakingsListViewComponent extends AbstractVisbosComponent implements OnInit {

  actions = [
    {
      icon: 'fa-plus',
      label: 'Neue Inventur',
      action: () => this.onAddStocktakingClicked.apply(this),
      helpText: 'Eine neue Inventur anlegen'
    }
  ];


  private stocktakings$: ApolloQueryObservable<FetchStocktakingsQuery>;
  public stocktakings: Stocktaking[];

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private router: Router, private route: ActivatedRoute,
              private stocktakingService: StocktakingService) {
    super(sessionActions, cd);
  }


  ngOnInit(): void {
    super.ngOnInit();

    this.stocktakings$ = this.stocktakingService.fetchStocktakings();
    this.addComponentData(this.stocktakings$);
    this.addSubscription(this.stocktakings$.subscribe(res => {
      this.stocktakings = res.data.stocktakings;
    }));

  }

  onAddStocktakingClicked() {
    this.router.navigate(['./neu'], {relativeTo: this.route});
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stocktaking/views/stocktakings-list-view/stocktakings-list-view.component.ts